namespace $ {
	export class $mol_avatar extends $mol_icon {
		
		/**
		 * ```tree
		 * view_box \0 0 24 24
		 * ```
		 */
		view_box() {
			return "0 0 24 24"
		}
		
		/**
		 * ```tree
		 * id \
		 * ```
		 */
		id() {
			return ""
		}
		
		/**
		 * ```tree
		 * path \M 12 12 l 0 0 M 0 0 l 0 0 M 24 24 l 0 0 M 0 24 l 0 0 M 24 0 l 0 0
		 * ```
		 */
		path() {
			return "M 12 12 l 0 0 M 0 0 l 0 0 M 24 24 l 0 0 M 0 24 l 0 0 M 24 0 l 0 0"
		}
	}
	
}

